define("auth/routes/forgot-email", ["exports", "@ember/service", "@ember/routing/route", "ember-concurrency-decorators"], function (_exports, _service, _route, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let ForgotEmailRoute = (_class = class ForgotEmailRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);
    }

    setupController(controller) {
      controller.setProperties({
        handle: null,
        submitForgotEmail: this.submitForgotEmail
      });
    }

    *submitForgotEmail(handle) {
      let profile_type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'instagram';

      try {
        yield fetch("/api/v2/social_profiles/email_account_owner.json", {
          method: 'POST',
          headers: {
            'Content-type': 'application/json'
          },
          body: JSON.stringify({
            social_profile: {
              handle,
              profile_type
            }
          })
        });
        this.alerts.success(this.intl.t('alerts.authorization.forgot_email_page.success', {
          username: handle
        }));
      } catch (error) {
        this.alerts.alert(this.intl.t('alerts.errors.forgot_email'));
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "submitForgotEmail", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "submitForgotEmail"), _class.prototype)), _class);
  _exports.default = ForgotEmailRoute;
});